import { FC, useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'

import {
  BetesaCount,
  BetesaTitle,
  Container,
  LoaderContainer,
  Tab,
  TabContainer,
  WrapperTitle,
  SearchContainer,
  HeaderContainer,
} from './styled'
import { MainLayout } from 'views/layouts'
import BluesiteTableComponent from 'views/components/UI/BluesiteTable'
import getAllUninterpretedBetesas from 'services/common/betesa/getBetesaUninterpreted'
import { ACTIONS, HEADER, SEARCH_LABEL } from './constants'
import InterpretationButton from './components/interpretation-button/interpretation-button'
import Loader from 'views/components/UI/Loader'
import SearchBar from 'views/components/Searchbar'

type UninterpretedBetesas = {
  user_name: string
  company_name: string
  betesa_result_id: number
}

const BetesaInterpretations: FC = () => {
  const { token } = useSelector((state: any) => state.user)
  const [betesasWithoutPreviousInterpretation, setBetesasWithoutPreviousInterpretation] = useState<
    UninterpretedBetesas[] | []
  >([])
  const [betesasWithPreviousInterpretation, setBetesasWithPreviousInterpretation] = useState<
    UninterpretedBetesas[] | []
  >([])
  const [skipWith, setSkipWith] = useState(0)
  const [skipWithout, setSkipWithout] = useState(0)
  const [totalPages, setTotalPages] = useState(0)
  const [isLoading, setIsLoading] = useState(false)
  const [searchParam, setSearchParam] = useState('')
  const [activeTab, setActiveTab] = useState('withoutPrevious')
  const [totalWithoutPrevious, setTotalWithoutPrevious] = useState(0)
  const [totalWithPrevious, setTotalWithPrevious] = useState(0)

  const limit = 7

  const location = useLocation()

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search)
    const tab = searchParams.get('activeTab')
    if (tab) {
      setActiveTab(tab)
    }
  }, [location.search])

  useEffect(() => {
    if (searchParam.length !== 0) return

    setIsLoading(true)
    getAllUninterpretedBetesas(token, skipWith, skipWithout, searchParam).then((res) => {
      setBetesasWithoutPreviousInterpretation(res.betesasWithoutPreviousInterpretation)
      setBetesasWithPreviousInterpretation(res.betesasWithPreviousInterpretation)
      setTotalPages(
        activeTab === 'withoutPrevious'
          ? res.total_pages_without_previous_interpretation
          : res.total_pages_with_previous_interpretation
      )
      setTotalWithoutPrevious(res.total_without_previous_interpretation)
      setTotalWithPrevious(res.total_with_previous_interpretation)
      setIsLoading(false)
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token, skipWith, skipWithout, searchParam, activeTab])

  const handleSearch = (search: string) => {
    setSearchParam(search)
    if (search.length === 0) return

    getAllUninterpretedBetesas(token, skipWith, skipWithout, search).then((res) => {
      setBetesasWithoutPreviousInterpretation(res.betesasWithoutPreviousInterpretation)
      setBetesasWithPreviousInterpretation(res.betesasWithPreviousInterpretation)
      setTotalPages(
        activeTab === 'withoutPrevious'
          ? res.total_pages_without_previous_interpretation
          : res.total_pages_with_previous_interpretation
      )
    })
  }

  const dataToShow =
    activeTab === 'withoutPrevious' ? betesasWithoutPreviousInterpretation : betesasWithPreviousInterpretation

  const dataWithTab = dataToShow.map((item) => ({
    ...item,
    activeTab,
  }))

  const totalUsers = activeTab === 'withoutPrevious' ? totalWithoutPrevious : totalWithPrevious

  const totalBelesas = totalWithoutPrevious + totalWithPrevious

  const handlePagination = (page: number) => {
    if (activeTab === 'withoutPrevious') {
      setSkipWithout((page - 1) * limit)
    } else {
      setSkipWith((page - 1) * limit)
    }
  }

  const currentPage =
    activeTab === 'withoutPrevious' ? Math.floor(skipWithout / limit) + 1 : Math.floor(skipWith / limit) + 1

  return (
    <MainLayout>
      {isLoading ? (
        <LoaderContainer>
          <Loader />
        </LoaderContainer>
      ) : (
        <Container>
          <HeaderContainer>
            <WrapperTitle>
              <BetesaTitle>Betesas por interpretar</BetesaTitle>
              <BetesaCount>Total usuarios: {totalBelesas}</BetesaCount>
            </WrapperTitle>
            <SearchContainer>
              <SearchBar
                label="Nombre de usuario o nombre de empresa"
                value={searchParam}
                onChange={(e) => setSearchParam(e.target.value)}
                onClick={() => handleSearch(searchParam)}
              />
            </SearchContainer>
          </HeaderContainer>
          <TabContainer>
            <Tab active={activeTab === 'withoutPrevious'} onClick={() => setActiveTab('withoutPrevious')}>
              Usuarios primer Betesa
            </Tab>
            <Tab active={activeTab === 'withPrevious'} onClick={() => setActiveTab('withPrevious')}>
              Usuarios con Betesas anteriores
            </Tab>
          </TabContainer>
          <BetesaCount style={{ marginBottom: '40px' }}>
            Total usuarios {activeTab === 'withoutPrevious' ? 'primer Betesa' : 'con Betesas anteriores'}: {totalUsers}
          </BetesaCount>
          <BluesiteTableComponent
            ActionComponent={InterpretationButton}
            data={dataWithTab}
            headers={HEADER}
            actions={ACTIONS}
            searchBar={false}
            searchLabel={SEARCH_LABEL}
            currentPage={currentPage}
            handlePagination={handlePagination}
            totalPages={totalPages}
            fetchSearchData={handleSearch}
            onSearch={(e) => handleSearch(e)}
          />
        </Container>
      )}
    </MainLayout>
  )
}

export default BetesaInterpretations
